import React from 'react'

import { Link, useHistory } from 'react-router-dom'

import {
  Box,
  Paper,
  Button,
  Typography,
  CircularProgress,
} from '@material-ui/core'

import { routes } from 'routes'
import { useAuth, useSeller, useSnackbar, useWindowSize } from 'hooks'
import { CardBenefit, CardPaymentMethod } from './components'
import onlineSale from 'images/paymentMethodsConfiguration/onlineSale.png'
import processing from 'images/paymentMethodsConfiguration/processing.png'
import riskAnalysis from 'images/paymentMethodsConfiguration/riskAnalysis.png'
import landingPage1 from 'images/paymentMethodsConfiguration/landingPage1.png'
import landingPage2 from 'images/paymentMethodsConfiguration/landingPage2.png'

const PaymentMethods = () => {
  const history = useHistory()
  const auth = useAuth()
  const seller = useSeller()
  const snackbar = useSnackbar()
  const windowSize = useWindowSize()
  const [isLoading, setIsLoading] = React.useState(true)
  const [
    isConfiguredPaymentMethods,
    setIsConfiguredPaymentMethods,
  ] = React.useState(false)

  React.useEffect(() => {
    const checkPaymentMethodsConfiguration = async () => {
      try {
        const isConfiguredPaymentMethods = await seller.isConfiguredPaymentMethods()
        setIsConfiguredPaymentMethods(isConfiguredPaymentMethods)
        setIsLoading(false)
      } catch (error) {
        snackbar.open({
          message: 'Erro ao verificar os meios de pagamento! Tente novamente!',
          variant: 'error',
        })

        history.push(auth.checkMainRoute(auth.permissions))
      }
    }

    checkPaymentMethodsConfiguration()
  }, [history, auth, seller, snackbar])

  if (isLoading) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        component={Paper}
        p={4}
      >
        <CircularProgress size={60} />
      </Box>
    )
  }

  return (
    <Box component={Paper} p={4}>
      <Box
        display="flex"
        flexDirection={{ xs: 'column-reverse', sm: 'row' }}
        alignItems="flex-start"
        justifyContent={{ xs: 'center', sm: 'space-between' }}
        mb={8}
      >
        <Box width={{ xs: '100%', sm: 1 / 2, md: 2 / 6 }}>
          <Box width="100%" mb={8} component="img" src={landingPage1} />

          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth={!windowSize.isDesktop}
            component={Link}
            to={
              isConfiguredPaymentMethods
                ? routes.settings.paymentMethods.edit
                : routes.settings.paymentMethods.steps.integrationToken
            }
          >
            Configurar pagamentos
          </Button>
        </Box>

        <Box
          width={{ xs: '100%', sm: 1 / 2, md: 3 / 7 }}
          component="img"
          src={landingPage2}
        />
      </Box>

      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'center', sm: 'flex-start' }}
      >
        <CardBenefit
          image={onlineSale}
          imageAlt="Venda online sem burocracia. Aceite as principais formas de pagamento do mercado, sem precisar correr atrás de contratos com gateways, adquirentes ou antifraude."
          description="Venda online sem burocracia. Aceite as principais formas de pagamento do mercado, sem precisar correr atrás de contratos com gateways, adquirentes ou antifraude."
        />

        <CardBenefit
          image={processing}
          imageAlt="Quando sua adquirente primária retornar algum erro/falha no pagamento, reprocessamos o mesmo em uma outra adquirente*."
          description="Quando sua adquirente primária retornar algum erro/falha no pagamento, reprocessamos o mesmo em uma outra adquirente*."
        />

        <CardBenefit
          image={riskAnalysis}
          imageAlt="Equipe de análise de risco que garante maior segurança, conversão e agilidade das suas operações."
          description="Equipe de análise de risco que garante maior segurança, conversão e agilidade das suas operações."
        />
      </Box>

      <Box my={4}>
        <Typography variant="body2">
          *A adquirente de reprocessamento deve ser configurada para habilitar a
          funcionalidade.
        </Typography>
      </Box>

      <Box my={4}>
        <Box textAlign={{ xs: 'center', sm: 'left' }} mb={4}>
          <Typography variant="h4" color="primary">
            FORMAS DE PAGAMENTO ACEITAS
          </Typography>
        </Box>

        <Box
          display={{ xs: 'grid', sm: 'none' }}
          gridTemplateColumns="1fr"
          gridGap={16}
          mb={8}
        >
          <CardPaymentMethod title="Boleto" />
          <CardPaymentMethod
            title="Transferência bancária"
            description="Banco do Brasil, Bradesco e Itaú"
          />
          <CardPaymentMethod
            title="Cartão de crédito"
            description="Visa, Mastercard, Elo, Hipercard, American Express, Aura, Diners Club, JCB e Discover"
          />
          <CardPaymentMethod title="Saldo Yapay" />
        </Box>

        <Box
          display={{ xs: 'none', sm: 'grid' }}
          gridTemplateColumns="1fr 1fr"
          gridGap={16}
          mb={16}
        >
          <CardPaymentMethod
            title="Transferência bancária"
            description="Banco do Brasil, Bradesco e Itaú"
          />
          <CardPaymentMethod
            title="Cartão de crédito"
            description="Visa, Mastercard, Elo, Hipercard, American Express, Aura, Diners Club, JCB e Discover"
          />
          <CardPaymentMethod title="Boleto" />
          <CardPaymentMethod title="Saldo Yapay" />
        </Box>

        <Box>
          <Typography color="textSecondary">
            Se você não é cliente do Intermediador Yapay e deseja configurar as
            formas de pagamento, favor entrar em contato com nossa equipe
            através do e-mail{' '}
            <Box component="span" fontWeight="fontWeightMedium">
              atendimento@yapay.com.br
            </Box>
            .
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default PaymentMethods
